var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextCentericon = function SvgTextCentericon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.8 4H1.2a.4.4 0 0 1-.4-.4v-.8a.4.4 0 0 1 .4-.4h13.6a.4.4 0 0 1 .4.4v.8a.4.4 0 0 1-.4.4Zm-1.2 4.4v-.8a.4.4 0 0 0-.4-.4H2.8a.4.4 0 0 0-.4.4v.8c0 .22.18.4.4.4h10.4a.4.4 0 0 0 .4-.4Zm1.6 4v.8a.4.4 0 0 1-.4.4H1.2a.4.4 0 0 1-.4-.4v-.8a.4.4 0 0 1 .4-.4h13.6a.4.4 0 0 1 .4.4Z",
    clipRule: "evenodd"
  })));
};
export default SvgTextCentericon;